"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@emotion/core");
const lodash_1 = require("lodash");
const design_system_1 = require("@zapier/design-system");
const utils_1 = require("./utils");
function getValueTextColor({ hasEmptyRequiredFields, hasEmptyOptionalFields, }) {
    if (hasEmptyOptionalFields) {
        return design_system_1.Colors.grey500;
    }
    if (hasEmptyRequiredFields) {
        return design_system_1.Colors.red600;
    }
    return 'inherit';
}
const Styles = {
    getRootStyles({ isNested }) {
        const containerCSS = isNested
            ? undefined
            : {
                overflow: 'auto',
                maxHeight: 400,
            };
        return Object.assign({ color: design_system_1.Colors.grey700, fontSize: 15, lineHeight: 1.6, paddingLeft: isNested ? 20 : 0 }, containerCSS);
    },
    getKeyStyles({ hasEmptyRequiredFields, }) {
        return {
            color: hasEmptyRequiredFields ? design_system_1.Colors.red600 : 'inherit',
            fontWeight: 'bold',
            lineHeight: 1.6,
            minWidth: 'max-content',
            '&::after': {
                content: '":"',
            },
        };
    },
    getValueStyles({ hasEmptyRequiredFields, hasEmptyOptionalFields, }) {
        return {
            color: getValueTextColor({
                hasEmptyOptionalFields,
                hasEmptyRequiredFields,
            }),
            paddingLeft: 5,
        };
    },
};
function SampleDataView({ data, isNested = false, hasEmptyRequiredFields, hasEmptyOptionalFields, viewRef, }) {
    const map = utils_1.toMap(data);
    const content = [];
    map.forEach((value, key) => {
        const isComplex = lodash_1.isObject(value);
        const isSimpleArrayValue = lodash_1.isArray(data) && !isComplex;
        const dataKey = utils_1.getKey(key, isSimpleArrayValue);
        content.push(core_1.jsx("div", { css: {
                display: isComplex ? 'block' : 'flex',
            }, key: key },
            String(key) && (core_1.jsx("div", { css: Styles.getKeyStyles({ hasEmptyRequiredFields }), title: dataKey.toString() }, dataKey)),
            isComplex ? (core_1.jsx(SampleDataView, { data: value, hasEmptyOptionalFields: hasEmptyOptionalFields, hasEmptyRequiredFields: hasEmptyRequiredFields, isNested: true })) : (core_1.jsx("div", { style: Styles.getValueStyles({
                    hasEmptyRequiredFields,
                    hasEmptyOptionalFields,
                }) }, utils_1.formatValue({
                value,
                hasEmptyRequiredFields,
                hasEmptyOptionalFields,
            })))));
    });
    return (core_1.jsx("div", { css: Styles.getRootStyles({ isNested }), ref: viewRef }, content));
}
exports.default = SampleDataView;
